export const RangeDataHooks = {
    Label: 'label',
    SelectedMinValue: 'selected-min-value',
    SelectedMaxValue: 'selected-max-value',
    errorMessageWrapper: 'errormessagewrapper-message',
};
//# sourceMappingURL=types.js.map